import React, { useState, useEffect } from "react";

export const svg = `<svg width="20" height="20" viewbox="0 0 20 20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.40385 8.98713L1.97192 8.2688V12.6362L6.40385 11.9179V8.98713Z" fill="currentColor"></path><path d="M8.62691 8.98706H7.14478V11.9034H8.62691V8.98706Z" fill="currentColor"></path><path d="M11.9399 6.44427L12.6664 2.06256H8.24902L8.97555 6.44427H11.9399Z" fill="currentColor"></path><path d="M11.9251 7.17696H8.97534V8.6423H11.9251V7.17696Z" fill="currentColor"></path><path d="M10.4572 9.41669L9.40918 10.4528L10.4572 11.489L11.5052 10.4528L10.4572 9.41669Z" fill="currentColor"></path><path d="M12.2886 14.3171L14.8896 17.9374L18.0283 14.8343L14.3665 12.2627L12.2886 14.3171Z" fill="currentColor"></path><path d="M12.8045 10.7137L10.7188 12.7759L11.7668 13.812L13.8525 11.7499L12.8045 10.7137Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
